import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {Box} from '@mui/material'
import DataTable, {PaginationState} from 'src/components-new/data/DataTable'
import InlineMessage from 'src/components-new/feedback/InlineMessage'
import {STATUS} from 'src/constants/constants'
import {useAppSelector} from 'src/hooks'
import apiClient from 'src/services/apiClient'
import {buildColumns, PerformanceRecord} from './columns'

const PerformancesNew = (): JSX.Element => {
  const performancesColumnOptions = useAppSelector(
    state => state.pspConfigReducer.data.performancesConfigurations?.columnOptions
  )

  const [data, setData] = useState<PerformanceRecord[]>([])
  const [count, setCount] = useState(0)
  const [loadStatus, setLoadStatus] = useState<string>(STATUS.PENDING)
  const [pagination, setPagination] = useState<PaginationState>({page: 0, rowsPerPage: 10})

  const columns = useMemo(() => buildColumns(performancesColumnOptions), [performancesColumnOptions])

  const fetchData = useCallback(async () => {
    setLoadStatus(STATUS.PENDING)
    const fetched = (await apiClient.getUserPerformances(setLoadStatus, {
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      order: '',
    })) ?? []
    setData((fetched as any[]).map((row, idx) => ({...row, id: idx})))

    const cnt = (await apiClient.getUserPerformancesCount(() => {})) ?? 0
    setCount(Number(cnt))
  }, [pagination])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
      {loadStatus === STATUS.REJECTED && (
        <InlineMessage
          severity="error"
          onClose={() => setLoadStatus(STATUS.FULFILLED)}
        >
          {"Errore nel recuperare le prestazioni dell'utente."}
        </InlineMessage>
      )}

      <DataTable<PerformanceRecord>
        columns={columns}
        rows={data}
        keyField="id"
        loading={loadStatus === STATUS.PENDING}
        emptyMessage="Nessuna prestazione trovata"
        totalElements={count}
        pagination={pagination}
        onPaginationChange={setPagination}
      />
    </Box>
  )
}

export default PerformancesNew
